import { ReactNode } from "react";
import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";

const { bannerTone, radius, typeScale } = adminTokens;

export type NoteTone = "info" | "error";

// The design sets the text of a note in 13px at a line height of 1.5, between the meta and body
// styles (NOTE-R2).
const noteTextSize = "13px";
const noteLineHeight = 1.5;
const notePadding = "12px 14px";

const Box = styled.div<{ $tone: NoteTone }>`
  padding: ${notePadding};
  border: 1px solid ${({ $tone }) => bannerTone[$tone].border};
  border-radius: ${radius.row}px;
  background-color: ${({ $tone }) => bannerTone[$tone].background};
  color: ${({ $tone }) => bannerTone[$tone].text};
  font-family: ${typeScale.body.fontFamily};
  font-size: ${noteTextSize};
  line-height: ${noteLineHeight};
`;

interface NoteProps {
  tone: NoteTone;
  children: ReactNode;
}

// A short explanation of a state inside a card, where a banner would report an event: text only,
// no title, no icon and no action (NOTE-R1…R4).
export const Note = ({ tone, children }: NoteProps) => (
  <Box $tone={tone} role="note">
    {children}
  </Box>
);
